import type { EventData } from '../types/EventData';

export const hasEventTags = (event: EventData): boolean => event.tags.length > 0;

export const UNTAGGED = 'Untagged';

export function getTagsFromEvents(events: EventData[]): string[] {
  if (!events) return [];
  const uniqueTags = new Set<string>();
  let unTaggedEvents = false;
  events.forEach(event => {
    event.tags.forEach(tag => uniqueTags.add(tag));
    unTaggedEvents = unTaggedEvents || !hasEventTags(event);
  });
  if (unTaggedEvents) {
    uniqueTags.add(UNTAGGED);
  }
  return Array.from(uniqueTags);
}
